import {NatGetRidge} from './NatGetRidge'
import Http from '../../../../network/Http'

export default class NatRidgeRepo {
    http: Http;

    constructor(http: Http) {
        this.http = http
    }

    // 棟一覧取得
    async getRidgeList(condominiumCd?: string): Promise<NatGetRidge> {
        const query = (condominiumCd) ? `?condominiumCd=${encodeURIComponent(condominiumCd)}` : '';
        return await this.http.get(`/api/common/ridge${query}`);
    }

}
